define('modules/page_listing/views/search_layout',['require','exports','module','backbone','base/layout','./../models/querystring','lib/util','./search_tagcloud','./search_list','../collections/tags','../controllers/search','ldsh!../templates/search_layout'],function (require, exports, module) {
  'use strict';

  var Backbone = require('backbone'),
    Layout = require('base/layout'),
    Querystring = require('./../models/querystring'),
    util = require('lib/util');

  var SearchCloudView = require('./search_tagcloud'),
    SearchListView = require('./search_list'),
    TagCollection = require('../collections/tags');

  var SearchController = require('../controllers/search');

  module.exports = Layout.extend({
    template: require('ldsh!../templates/search_layout'),
    className: 'ed-search-filter',

    regions: {
      tagcloud: '.js-tag-cloud',
      taglist: '.js-tag-list',
    },

    events: {
      'submit form': 'onSubmit',
      'keydown input': 'onKeyDown',
      'keyup input': 'onKeyUp',
    },

    initialize: function (options) {
      options = options || {};
      this.filters = options.filters;
      var listView = new SearchListView(),
        tagModels = this.filters.getTags().map(function (text) {
          return { text: text };
        }),
        tagCollection = new TagCollection(tagModels);
      this.searchText = this.filters.get('name');
      this.regions.taglist.show(listView);
      this.regions.tagcloud.show(
        new SearchCloudView({
          collection: tagCollection,
        })
      );
      this.listenTo(listView, 'tag:select', this.addTagToCloud);
      this.listenTo(tagCollection, 'add remove', this.checkTagCloudVisibility);
    },

    onSubmit: function (e) {
      e.preventDefault();

      if (this.$taglist.currentView.hasTagSelected()) {
        return;
      }

      this.filters.set({
        name: this.searchText.trim(),
        tag: this.$tagcloud.currentView.composeQuery(),
      });

      var filtersMap = this.filters.toAttributesMap();
      var serializedQuery = Querystring.serialize(_.pairs(filtersMap));
      var url = 'pages?' + serializedQuery;
      var fragment = Backbone.history.fragment;

      if (url === fragment) {
        return;
      }
      window.location = url;
    },

    onRender: function () {
      this.$('input').focus().val(this.searchText);

      this.toggleTagList(this.searchText.length < this.minSearchLength);
      this.checkTagCloudVisibility();
      this.$el.i18n();
    },

    checkTagCloudVisibility: function () {
      var tagcloud = this.$tagcloud.currentView || this.$tagcloud._pendingView,
        isShown = !tagcloud || !tagcloud.collection.length;
      this.toggleTagCloud(isShown);
    },
  });

  util.mixin(module.exports, SearchController);
});

